import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

/** Status pill — mono uppercase, marca lexicon (SIN RECURSO, SIN ASIGNAR, FLOTA…). */
const badgeVariants = cva(
  'inline-flex items-center rounded-[20px] px-[8px] py-[2px] font-mono text-[9px] font-bold uppercase tracking-[.4px]',
  {
    variants: {
      variant: {
        bad: 'bg-s-badb text-s-bad',
        warn: 'bg-s-warnb text-s-warn',
        ok: 'bg-s-okb text-s-ok',
        info: 'bg-s-infob text-s-info',
        flota: 'bg-[#eef1f5] text-s-mid',
        accent: 'bg-s-accentSoft text-s-accent',
      },
    },
    defaultVariants: { variant: 'accent' },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
